import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const like = css`
  background-image: linear-gradient(45deg, ${theme.colors.peoople['azul-claro-medio']} 0%, ${theme.colors.peoople['azul-electrico']} 100%);
  -webkit-text-fill-color: transparent;
  background-clip: text;
  &:hover {
    background-image: linear-gradient(135deg, ${theme.colors.peoople['azul-claro-medio']} 0%, ${theme.colors.peoople['azul-electrico']} 100%);
  }
`;
